import {TDriverEnhanced} from "../components/common/types/enhanced";
import {DispatchGroup, Driver} from "../generated/graphql";

export const buildEnhancedDrivers = (drivers: Driver[], allDriverGroups: DispatchGroup[]): TDriverEnhanced[] => {
  return drivers.map((driver) => {
    return {
      ...driver,
      dispatchGroup: allDriverGroups.find((dg) => dg.dispatchGroupId === driver.dispatchGroupId)
    };
  });
};
